module.exports = __webpack_public_path__ + "img/facebook.ef3d1b43.svg";